import './Wizard.scss';

window.addMusicStyle = function () { }
window.ClmCreateEventControllerStep3_OnSuccess = function () { }
window.ClmCreateEventControllerStep3_OnSelect = function () { }

window.AddAntiForgeryToken = function (data) {
    data.__RequestVerificationToken = $('#__AjaxAntiForgeryForm input[name=__RequestVerificationToken]').val()
    return data
}

$(function () {
    $('#cancel-wizard').click(function (e) {
        e.preventDefault()
        e.stopPropagation()

        if (confirm('Möchtest du die Erstellung dieses Events wirklich abbrechen?')) {
            $.post(clmCreateEventControllerInit.CancelEventUrl, AddAntiForgeryToken(
                {
                    token: compositeAppInit.AccessToken,
                    id: clmCreateEventControllerInit.EventIdEncoded
                }), 'json').done(function (data) {
                    window.location.replace(data.redirectToUrl);
                });
        }
    })

    $('#save-and-exit').click(function (e) {
        e.preventDefault()
        e.stopPropagation()

        $("#SaveAndExit").val("true")
        $(".wizard-form").submit()
    })
})